export class RegexpUtility {
  // Reference for email validation regex: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
  static Email: RegExp = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

  // Reference for web page validation regex: https://regexr.com/39nr7
  static WebUrl: RegExp = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;

  static PhoneNumber: RegExp = /^(\+)?[0-9]+$/;
}
